import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { ResponsiveValue, variant } from 'styled-system';
import { fontSizes } from '../../theme/fonts';
import { JigsawComponent, solvSystem, sx } from '../../theme/system';
import { SolvThemeType } from '../../theme/theme';
import Box from '../Box/Box';

export const iconSizes = {
  sm: { fontSize: fontSizes.lg },
  base: { fontSize: fontSizes.xl },
};

const IconBaseRoot = styled(Box)<JigsawComponent>(
  { display: 'inline-flex' },
  variant({ variants: iconSizes, prop: '$size' }),
  solvSystem,
  sx,
);

export type IconBaseProps = {
  size?:
    | ResponsiveValue<keyof typeof iconSizes, SolvThemeType>
    | string
    | number;
} & JigsawComponent;

const IconBase = ({
  children,
  size = 'base',
  ...rest
}: PropsWithChildren<IconBaseProps>) => {
  const style =
    (typeof size === 'string' && !Object.keys(iconSizes).includes(size)) ||
    typeof size === 'number'
      ? { fontSize: size }
      : {};

  return (
    <IconBaseRoot
      alignItems="center"
      justifyContent="center"
      $size={size}
      style={style}
      {...rest}
    >
      {children}
    </IconBaseRoot>
  );
};

export default IconBase;
